import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CheckToggle from 'components/CheckToggle';
import { NOTIFICATION_STATUS } from 'models/Notification';
import NotificationsContext from 'providers/Notifications/Notifications.context';
import { getIsNotificationUnread } from 'utils';

import './NotificationUnreadToggle.styles.scss';

type NotificationUnreadToggleProps = {
  className?: string;
};

const NotificationUnreadToggle: React.FC<NotificationUnreadToggleProps> = (
  props,
) => {
  const { className } = props;

  const { fetchingNotifications, notificationStatus, setNotificationStatus } =
    useContext(NotificationsContext);

  const classes = classNames('notification-unread-toggle', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <CheckToggle
        disabled={fetchingNotifications}
        checked={getIsNotificationUnread(notificationStatus)}
        onChange={({ target: { checked } }) =>
          setNotificationStatus(
            checked ? NOTIFICATION_STATUS.UNREAD : NOTIFICATION_STATUS.ALL,
          )
        }
      />
      {t('unreadOnly')}
    </div>
  );
};

export default NotificationUnreadToggle;
